<template>
  <div
    class="bg-white rounded-lg shadow-lg overflow-hidden flex flex-col h-full"
  >
    <!-- Profile Picture -->
    <div class="relative bg-gray-200 h-64 flex items-center justify-center">
      <img
        :src="agent.imageUrl || '/images/profile-pic-default.svg'"
        :alt="agent.name"
        :class="
          agent.imageUrl
            ? 'w-full h-full object-cover'
            : 'w-24 h-24 object-contain'
        "
      />

      <!-- Pruta Badge (top left) -->
      <div class="absolute top-2 left-2 w-12 h-12">
        <img
          src="/images/logo-pruta-circle-small.svg"
          alt="Pruta Verified"
          class="w-full h-full"
        />
      </div>

      <!-- Agency Logo (top right) -->
      <div
        v-if="agent.agencyLogo"
        class="absolute top-2 right-2 w-12 h-12 bg-white rounded-md flex items-center justify-center"
      >
        <img
          :src="agent.agencyLogo"
          :alt="agent.agency"
          class="w-full h-full object-contain"
        />
      </div>
    </div>

    <!-- Card Content -->
    <div class="p-4 flex-1 flex flex-col">
      <!-- Header -->
      <div class="flex items-start justify-between mb-2">
        <div class="flex-1">
          <h3 class="text-2xl font-semibold text-gray-darkest">
            {{ capitalizeFirstLetter(agent.firstName) }}
            {{ capitalizeFirstLetter(agent.lastName) }}
          </h3>
        </div>
        <div class="flex flex-col items-end justify-between">
          <!-- Rating -->
          <div class="flex items-center gap-1 mb-2">
            <svg class="w-4 h-4 fill-brand" viewBox="0 0 15 14">
              <path
                d="M7.5 0L9.18386 5.18237H14.6329L10.2245 8.38525L11.9084 13.5676L7.5 10.3647L3.09161 13.5676L4.77547 8.38525L0.367076 5.18237H5.81614L7.5 0Z"
              />
            </svg>
            <span class="text-xs font-medium text-gray-darker">{{
              agent.rating
            }}</span>
          </div>

          <!-- Languages -->
          <div
            class="flex items-end justify-end flex-wrap max-w-20 text-left gap-1 text-sm font-medium text-gray-dark"
          >
            <span v-for="(lang, index) in agent.languages" :key="index">
              {{ capitalizeFirstLetter(lang)
              }}<span v-if="index < agent.languages.length - 1">, </span>
            </span>
          </div>
        </div>
      </div>

      <!-- Agency -->
      <p class="text-sm font-medium text-dark-grey mb-2">{{ agent.agency }}</p>

      <!-- Suburbs -->
      <div class="border-t border-light-grey py-1 mb-4 flex-1">
        <!-- <p class="text-sm font-medium text-gray-darker mb-2">Suburb</p> -->
        <div class="flex flex-wrap gap-2 py-2">
          <span
            v-for="(suburb, index) in agent.suburbs"
            :key="index"
            class="bg-gray-lighter border border-dark-grey rounded-full px-3 py-1 text-xs font-medium text-dark-grey"
          >
            {{ suburb }}
          </span>
        </div>
      </div>

      <!-- View Profile Button -->
      <Button variant="ghost" size="md" fullWidth @click="viewProfile">
        View profile
      </Button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  agent: {
    type: Object,
    required: true,
    default: () => ({
      id: "",
      firstName: "",
      lastName: "",
      rating: 0,
      languages: [],
      agency: "",
      suburbs: [],
      imageUrl: "",
      agencyLogo: "",
    }),
  },
});

const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const viewProfile = () => {
  if (props.agent?.id) {
    navigateTo(`/agent-public-profile/${props.agent.id}`);
  }
};
</script>
